<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dedication</span></p>
<p class="P_WFP_Quote__And__Centre_Alignment"><span>To Cindy Beason—who met me when I was a cadet,</span></p>
<p class="P_WFP_Quote__And__Centre_Alignment"><span>married me anyway, and supported me through everything.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?86afa028